import axiosInstance from "../../utils/config/config";

export const getAllEvents = () => async (dispatch) => {
  try {
    dispatch({
      type: "getAllEventsRequest",
    });
    const { data } = await axiosInstance.get(`/event/getAllEvents`);
    dispatch({
      type: "getAllEventsSuccess",
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: "getAllEventsFailure",
      payload: true,
    });
  }
};
